import { render, staticRenderFns } from "./Fullname.vue?vue&type=template&id=1758c516&"
import script from "./Fullname.vue?vue&type=script&lang=js&"
export * from "./Fullname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports